import { AsyncPipe, SlicePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { ActivatedRoute, RouterLink } from '@angular/router';

import { I18nModule } from '@spartacus/core';
import { KeyboardFocusModule } from '@spartacus/storefront';

import { DpSearchFacetPipe } from './search-facet.pipe';
import { FADE_IN_CONTENT_BY_HEIGHT_OPACITY } from '@app/core/constants/animations.constant';

import { DpFacetComponent } from '../facet.component';

@Component({
    selector: 'dp-facet-search',
    templateUrl: './facet-search.component.html',
    styleUrls: ['../facet.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        AsyncPipe,
        SlicePipe,
        RouterLink,
        KeyboardFocusModule,
        I18nModule,
        MatIcon,
        FormsModule,
        ReactiveFormsModule,
        DpSearchFacetPipe
    ],
    animations: [FADE_IN_CONTENT_BY_HEIGHT_OPACITY]
})
export class DpFacetSearchComponent extends DpFacetComponent {
  readonly route = inject(ActivatedRoute).snapshot.url;
  readonly searchControl = new FormControl<string>('');
}
